import { useIntl } from 'react-intl';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { GameplayTierStars } from '@sorare/core/src/components/card/GameplayTierStars';
import { glossary } from '@sorare/core/src/lib/glossary';
import type { PlayerPoolTier } from '@sorare/core/src/lib/playerPoolTiers';
import {
  playerPoolTierLabel,
  playerPoolTierSlug,
} from '@sorare/core/src/lib/playerPoolTiers';

import { PoolFilterSelect } from '#src/components/rewards/PoolFilterSelect/index.tsx';

type Props = {
  tiers: PlayerPoolTier[];
  selectedTierSlug: string;
  onChange: (tierSlug: string) => void;
};

export const PoolTierFilter = ({
  tiers,
  selectedTierSlug,
  onChange,
}: Props) => {
  const { formatMessage } = useIntl();

  return (
    <PoolFilterSelect
      name="pool-tier"
      header={formatMessage(glossary.tier)}
      options={tiers.map(tier => ({
        value: playerPoolTierSlug(tier),
        label: (
          <Horizontal as="span" gap={1}>
            {'gameplayTier' in tier && (
              <GameplayTierStars gameplayTier={tier.gameplayTier} />
            )}
            {playerPoolTierLabel(tier)}
          </Horizontal>
        ),
      }))}
      value={selectedTierSlug}
      onChange={onChange}
    />
  );
};
